module.exports = __webpack_public_path__ + "static/nagpa-ebf435bcf261e1aa175c94d62533d24b.png";